'use strict';

import { EntityCollection } from '@api/Collections/EntityCollection';
import type { ReportFilterOption } from '../../../Entities/Reports/Agency/ReportFilterOption';

export class ReportFilterOptionCollection extends EntityCollection<ReportFilterOption> {}
